<mat-card>
    <mat-card-title class="font-weight-bold caption-color">Consignee View</mat-card-title>
    <mat-divider></mat-divider>
    <mat-card-content class="pt-2">

<table class="table">
    <thead>
        <tr>
            <th>S.No</th>
            <th>Consignee Address </th>
            <th>Service By</th>
            <th>Distance</th>
            <th>ASP</th>
            
        </tr>
    </thead>
    <tbody>
        <tr *ngFor="let item of ConsineeDetails; let i = index;">
            <td>{{i+1}}</td>
            <td>{{item.ConsigneeAddrCode}}</td>  
            <td>{{item.ServiceBy}}</td> 
            <td>{{item.Distance}}</td> 
            <td>{{item.PartnerDesc}}</td>  
                   
        </tr>
    </tbody>
</table>
</mat-card-content>
</mat-card>
